import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const Verified: React.FC<Props> = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68" fill="none">
            <circle cx="33.971" cy="33.971" r="33.971" fill="#4CAF50" />
            <path d="M23.6875 47.6191L48.229 23.0777L67.116 41.9647L65.5424 46.5264L63.6378 50.7572L61.1461 54.4009L58.361 57.7512L55.1512 60.6768L51.5543 63.2152L47.3579 65.1542L45.0895 65.9442L42.8119 66.7435L23.6875 47.6191Z" fill="url(#paint0_linear_41664_27712)" />
            <g filter="url(#filter0_d_41664_27712)">
                <path fillRule="evenodd" clipRule="evenodd" d="M48.575 23.3953C47.2224 22.0427 45.0294 22.0427 43.6768 23.3953L26.4636 40.6085L19.9029 34.0479C18.5503 32.6953 16.3573 32.6953 15.0047 34.0479C13.6521 35.4005 13.6521 37.5935 15.0047 38.9461L23.9858 47.9272C25.3384 49.2798 27.5314 49.2798 28.8841 47.9272C28.9177 47.8936 28.9504 47.8595 28.9824 47.8249C29.129 47.7185 29.2693 47.5993 29.4015 47.4671L48.575 28.2935C49.9276 26.9409 49.9276 24.7479 48.575 23.3953Z" fill="#FFC107" />
            </g>
            <defs>
                <filter id="filter0_d_41664_27712" x="7.08806" y="15.4787" width="57.6866" height="48.6475" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="4.14131" dy="4.14131" />
                    <feGaussianBlur stdDeviation="5.52174" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_41664_27712" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_41664_27712" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_41664_27712" x1="35.9582" y1="35.3484" x2="58.361" y2="57.7512" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#338D36" />
                    <stop offset="1" stopColor="#4CAF50" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Verified;
